import React, { useEffect } from "react";
import Download from "../../components/DownloadButton";
import { Images } from "../../assets/images/HomePage";
import Footer from "../../components/Footer";
import { images } from "../../assets/images";
import Card from "./Card";
import Navbar from "../../components/Navbar/Navbar";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";

const Main = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="main">
        <div className="line">
          <img className="lineImg" src={Images.line} alt="line" />
        </div>

        <div class="wave">
          <div className="waveSectionGradient1"></div>
          <div className="waveSectionGradient2"></div>
          <div className="headLines">
            <div className="tag1">
              <span id="one">The Next - Generation</span>
              <br />
              <span id="two">Property Management Infrastructure</span>
            </div>
            <p className="tag3">
              A complete digitised ecosystem that correlates the Property
              Owners, Tenants and Individuals
            </p>
          </div>
          <div className="download-btns">
            <div className="appstore">
              <div className="apple-icon">
                <img src={images.Apple} alt="apple" />
              </div>
              <div className="store">
                <div className="store-line1">Download on</div>
                <div className="download">App Store</div>
              </div>
            </div>
            <div className="playstore">
              <div className="play-icon">
                <img src={images.PlayStore} alt="playstore" />
              </div>
              <div className="store">
                <div className="store-line1">Download on</div>
                <div className="download">Google Play</div>
              </div>
            </div>
          </div>
          <div className="audience">Target Audiences</div>
        </div>
        <div className="sectionCard">
          <div className="cards">
            <Card
              imageUrl={Images.landlord}
              title="Landlord"
              text="
          The Landlord can be a Property Owner of the Paying Guest, Co-living Space, Individual House, Apartment etc.
        "
              buttonText="Custom Button Text"
            />
            <Card
              imageUrl={Images.tenant}
              title="Tenant"
              text="
          The Tenant can be a student, working professional, family etc.
        "
              buttonText="Custom Button Text"
            />
            <Card
              imageUrl={Images.Individual}
              title="Individual"
              text="
          An Individual can be a student, self- employed person and even an entrepreneur.
        "
              buttonText="Custom Button Text"
            />
          </div>
        </div>
        <div className="sectionMarket">
          <div className="market">
            <div className="market_tag_lines">
              Curated For The Indian Real Estate Market
            </div>
            <div className="record">
              <div className="property">
                <p className="values">
                  10000 <span>+</span>
                </p>
                <p className="type typePro">Property Businesses</p>
              </div>
              <div className="tenants">
                <p className="values">
                  50 Lacs <span>+</span>
                </p>
                <p className="type">Tenants</p>
              </div>
              <div className="Indiancities">
                <p className="values">
                  50 <span>+</span>
                </p>
                <p className="type">Indian Cities</p>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="cities">
              <p>DELHI / NCR</p>
              <p>MUMBAI</p>
              <p>BENGALURU</p>
              <p>CHENNAI</p>
              <p>KOLKATA</p>
              <p>HYDERABAD</p>
              <p>PUNE</p>
              <p>PATNA</p>
              <p>AHMEDABAD</p>
              <p>JAIPUR</p>
              <p>LUCKNOW</p>
              <p>INDORE</p>
              <p>Chandigarh</p>
              <p>Thiruvananthapuram</p>
              <p>Bhubaneswar</p>
              <p>KOCHI</p>
              <p>Guwahati</p>
              <p>Visakhapatnam</p>
            </div>
            <div className="cities">
              <p>DELHI / NCR</p>
              <p>MUMBAI</p>
              <p>BENGALURU</p>
              <p>CHENNAI</p>
              <p>KOLKATA</p>
              <p>HYDERABAD</p>
              <p>PUNE</p>
              <p>PATNA</p>
              <p>AHMEDABAD</p>
              <p>JAIPUR</p>
              <p>LUCKNOW</p>
              <p>INDORE</p>
              <p>Chandigarh</p>
              <p>Thiruvananthapuram</p>
              <p>Bhubaneswar</p>
              <p>KOCHI</p>
              <p>Guwahati</p>
              <p>Visakhapatnam</p>
            </div>
          </div>
        </div>
        <div className="sectionBusiness">
          <div className="business">
            <div className="businessText">
              <p className="first">Business Reinvention</p>
              <p className="second">
                Bring agility to your rental property bussiness
              </p>
              <p className="third">
                Avasify enables you to do more than just streamline your
                operations, finance and management. Seamlessly enter new
                markets, enhance current systems, connect directly with
                consumers, and foster engagement through our large community of
                target audiences. Benefit from expert support from our
                professional services team accelerating your journey to
                realizing value with Avasify.
              </p>
            </div>
            <div>
              <img className="laptopImage" src={Images.laptop} alt="" />
              <img className="laptopImage2" src={Images.laptopImg} alt="" />
            </div>
          </div>
        </div>
        <div className="sectionContact">
          <div className="homeline2">
            <img src={Images.HomeLine2} alt="dash_line" />
          </div>
          <p className="first">
            Get on board with the comprehensive{" "}
            <span style={{ fontWeight: "bold" }}> Avasify Product Suite.</span>
          </p>
          <p className="contactBtn">Contact Us</p>
        </div>
        <div className="sectionOverview">An overview of the Product</div>
        <div className="sectionSolution">
          <p className="first">
            The all in one property solution you have been looking for
          </p>
          <div className="pointOne">
            <div className="landlordImg">
              <img className="landlord" src={Images.solutionLandlord} alt="" />
            </div>
            <span className="heading">Landlords</span>
          </div>
          <div className="landlordcontainer">
            <div className="landlordprocess">
              <p className="second">
                The next generation property management solution for your all
                needs.
              </p>
              <img className="landlordProcessImg" src={Images.flow} alt="" />
              <p className="third">
                We curated this for your rental property businesses to boost up
                your sales, manage the finance and day-to-day operations
              </p>
              <Link to="/landlord" className="fivth">
                Find More
              </Link>

              <p className="fourth">
                Simply onboard yourself; that's all that's required
              </p>
              <div className="MobileViewPhoneImage">
                <img className="landlordPhoneImage" src={Images.phone} alt="" />
              </div>
              <div className="download-btns">
                <Download text="Download on App Store" icon={images.Apple} />
                <Download
                  text="Download on Google Play"
                  icon={images.PlayStore}
                />
              </div>
            </div>
            <div className="phoneImage">
              <img className="landlordPhoneImage" src={Images.phone} alt="" />
            </div>
          </div>
        </div>
        <div className="Tenants">
          <div className="colorRed"></div>
          <div className="sectionTenants">
            <div className="phoneImage">
              <img src={Images.phone} alt="" />
            </div>
            <div className="container">
              {/* <div className="all"> */}
              <div className="pointTwo">
                <span className="heading">TENANTS</span>
                <div className="TenantImg">
                  <img className="landlord" src={Images.line2} alt="" />
                </div>
              </div>
              <div className="tenantFirst">
                {/* <p className="first">TENANTS</p> */}
                <p className="second">
                  {" "}
                  Take your rental experience to the next level with Avasify.
                </p>
              </div>
              <div className="allfeatures">
                <div className="features">
                  <div className="properties">
                    <p className="first">Find Properties</p>
                    <p className="second">
                      Smoothly discover and shortlist the properties as per your
                      choice on our platform
                    </p>
                  </div>
                  <img
                    className="tenantfeature1"
                    src={Images.tenantfeature1}
                    alt=""
                  />
                </div>
                <div className="features">
                  <div className="owners">
                    <p className="first">Connect with owners</p>
                    <p className="second">
                      Contact our validated landlords to make an informed choice
                      and booking
                    </p>
                  </div>
                  <img src={Images.tenantfeature2} alt="" />
                </div>
                <div className="features">
                  <div className="onBoard">
                    <p className="first">On board yourself digitally </p>
                    <p className="second">
                      Start your journey with us by completing the on boarding
                      and digital check in
                    </p>
                  </div>
                  <img src={Images.tenantfeature3} alt="" />
                </div>
                <div className="features">
                  <div className="experience">
                    <p className="first">Experience a digital stay</p>
                    <p className="second">
                      Our carefully curated product provides you a seamless
                      digital stay with a varieties of features
                    </p>
                  </div>
                  <img
                    className="tenantfeature4"
                    src={Images.tenantfeature4}
                    alt=""
                  />
                </div>
              </div>
              <div className="tenantFooter">
                <p className="first">
                  Immerse yourself in a location that propels you forward with
                  cutting-edge technology and enriching experiences
                </p>
                <p onClick={() => navigate("/tenant")} className="second">
                  Find More
                </p>
                <p className="third">Join with ease and motivate others</p>
              </div>
              <div className="MobileViewPhoneImage">
                <img className="landlordPhoneImage" src={Images.phone} alt="" />
              </div>
              <div className="download-btns">
                <Download text="Download on App Store" icon={images.Apple} />
                <Download
                  text="Download on Google Play"
                  icon={images.PlayStore}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="Individuals">
          <div className="sectionIndividuals">
            <div className="gradient"></div>

            <div className="container">
              <div className="pointOne">
                <div className="landlordImg">
                  <img className="landlord" src={Images.line3} alt="" />
                </div>
                <span className="heading">INDIVIDUAL</span>
              </div>
              <div className="individualFirst">
                {/* <p className="first">INDIVIDUAL</p> */}
                <p className="second">
                  {" "}
                  Start your individual journey towards establishing a source of
                  income.
                </p>
              </div>
              <div className="allfeatures">
                <div className="features">
                  <img
                    className="individualfeature1"
                    src={Images.individualfeature1}
                    alt=""
                  />
                  <div className="properties">
                    <p className="first">Install the Avasify App</p>
                    <p className="second">
                      Finish the registration steps to join and become a part of
                      the product
                    </p>
                  </div>
                </div>
                <div className="features">
                  <img src={Images.individualfeature2} alt="" />
                  <div className="owners">
                    <p className="first">Engage with the platform</p>
                    <p className="second">
                      Assist and advise both tenants and property owners
                      regarding our product's services.
                    </p>
                  </div>
                </div>
                <div className="features">
                  <img src={Images.individualfeature3} alt="" />
                  <div className="onBoard">
                    <p className="first">Collaborate with the properties</p>
                    <p className="second">
                      Discover, share and list the properties and become the
                      part of our large community
                    </p>
                  </div>
                </div>
                <div className="features">
                  <img
                    className="individualfeature4"
                    src={Images.individualfeature4}
                    alt=""
                  />
                  <div className="experience">
                    <p className="first">Generate Income</p>
                    <p className="second">
                      Generate earnings of up to 25,000 by participating in
                      multiple activities
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="phoneImage">
              <img src={Images.phone} alt="" />
            </div>
          </div>

          <div className="individualFooter">
            <p className="first">
              Unlock your potential to earn whether you're a student,
              self-employed, or an entrepreneur
            </p>
            <p onClick={() => navigate("/individual")} className="second">
              Find More
            </p>
            <p className="third">Accelerate your growth with us</p>
            <div className="MobileViewPhoneImage">
              <img className="landlordPhoneImage" src={Images.phone} alt="" />
            </div>
            <div className="download-btns">
              <Download text="Download on App Store" icon={images.Apple} />
              <Download
                text="Download on Google Play"
                icon={images.PlayStore}
              />
            </div>
          </div>
        </div>
        <div className="sectionModularSolution">
          <div className="backgroundColor">
            <div className="container">
              <div className="ModularSolution">
                <p className="first">Modular Solution</p>
                <p className="second">
                  A fully integrated product suite to refine the property
                  management
                </p>
                <p className="third">
                  Avasify enables you to do more than just streamline your
                  operations, finance and management. Seamlessly enter new
                  markets, enhance current systems, connect directly with
                  consumers, and foster engagement through our large community
                  of target audiences. Benefit from expert support from our
                  professional services team accelerating your journey to
                  realizing value with Avasify.
                </p>
                <div className="getStarted">
                  Get Started <span> {">"}</span>
                </div>
              </div>
              <div className="ModularImages">
                <div className="image1">
                  <img className="img1" src={Images.AutomateReciept} alt="" />

                  <img className="img2" src={Images.OnlinePayment} alt="" />
                </div>
                <div className="image2">
                  <img className="img3" src={Images.Inquiries} alt="" />
                  <img className="img4" src={Images.Analytics} alt="" />

                  <img className="img5" src={Images.Onboarding} alt="" />
                </div>
                <div className="image3">
                  <img className="img6" src={Images.complaint} alt="" />

                  <img className="img7" src={Images.kyc} alt="" />

                  <img className="img8" src={Images.property} alt="" />
                </div>
                <div className="image4">
                  <img className="img9" src={Images.paymentReminder} alt="" />

                  <img
                    className="img10"
                    src={Images.complaintAssignment}
                    alt=""
                  />
                </div>
              </div>
              <div className="MobileModularImges">
                <div className="slidingImg">
                  <img src={Images.img1} alt="img" />
                  <img src={Images.img2} alt="img" />
                  <img src={Images.img3} alt="img" />
                  <img src={Images.img4} alt="img" />
                  <img src={Images.img5} alt="img" />
                  <img src={Images.img6} alt="img" />
                  <img src={Images.img7} alt="img" />
                  <img src={Images.img8} alt="img" />
                  <img src={Images.img9} alt="img" />
                  {/* <img src={Images.img10} alt="img" /> */}
                  <img src={Images.img} alt="img" />
                </div>
                <div className="slidingImg">
                  <img src={Images.img1} alt="img" />
                  <img src={Images.img2} alt="img" />
                  <img src={Images.img3} alt="img" />
                  <img src={Images.img4} alt="img" />
                  <img src={Images.img5} alt="img" />
                  <img src={Images.img6} alt="img" />
                  <img src={Images.img7} alt="img" />
                  <img src={Images.img8} alt="img" />
                  <img src={Images.img9} alt="img" />
                  {/* <img src={Images.img10} alt="img" /> */}
                  <img src={Images.img} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sectionSuccess">
          <div className="container">
            <div className="success">
              <p className="first">
                {" "}
                Discover the key to your <br /> digital success with Avasify
              </p>
              <p className="second">
                We offer the remedy to your property bussiness challenges.
              </p>
              <div className="MobileViewPhoneImage">
                <img className="landlordPhoneImage" src={images.phone} alt="" />
              </div>
              <div className="download-btns">
                <Download
                  text="Download on App Store"
                  icon={images.blackApple}
                  bgColor="white"
                  textColor="black"
                />
                <Download
                  text="Download on Google Play"
                  icon={images.blackPlaystore}
                  bgColor="white"
                  textColor="black"
                />
              </div>
              <p className="third">
                <span> Have a question?</span> Feel free to contact us.{" "}
              </p>
              <div className="contactBtnContainer">
                <p className="contactBtn">Contact Us</p>
              </div>
            </div>
            <div className="phoneImage">
              <img src={images.phone} alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Main;
